var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.initialized ? _c('div', {
    staticClass: "design-tab"
  }, [_c('div', {
    staticClass: "pa-5"
  }, [_c('div', {
    staticClass: "label font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.$t('design_theme_color')) + " ")]), _c('div', {
    staticClass: "font-weight-light pa-3 pl-0"
  }, [_vm._v(" " + _vm._s(_vm.$t('design_theme_color_description')) + " ")]), _c('color-input', {
    staticClass: "pa-3 pl-0 pb-5",
    attrs: {
      "color": _vm.primary
    },
    on: {
      "update:color": function updateColor($event) {
        _vm.primary = $event;
      }
    }
  }), _c('div', {
    staticClass: "label font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.$t('design_text_color')) + " ")]), _c('div', {
    staticClass: "font-weight-light pa-3 pl-0"
  }, [_vm._v(" " + _vm._s(_vm.$t('design_text_color_description')) + " ")]), _c('color-input', {
    staticClass: "pa-3 pl-0 pb-5",
    attrs: {
      "color": _vm.text
    },
    on: {
      "update:color": function updateColor($event) {
        _vm.text = $event;
      }
    }
  }), _c('div', {
    staticClass: "label font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.$t('design_background_color')) + " ")]), _c('div', {
    staticClass: "font-weight-light pa-3 pl-0"
  }, [_vm._v(" " + _vm._s(_vm.$t('design_background_color_description')) + " ")]), _c('color-input', {
    staticClass: "pa-3 pl-0",
    attrs: {
      "color": _vm.background
    },
    on: {
      "update:color": function updateColor($event) {
        _vm.background = $event;
      }
    }
  }), _c('div', {
    staticClass: "label font-weight-bold mt-5"
  }, [_vm._v(" " + _vm._s(_vm.$t('font')) + ": ")]), _c('div', {
    staticClass: "font-weight-light pa-3 pl-0"
  }, [_vm._v(_vm._s(_vm.$t('design_font_description')) + " ")]), _c('div', {
    staticClass: "pa-3 pl-0"
  }, [_c('font-picker', {
    attrs: {
      "value": _vm.getThemeDefaultFont,
      "language-fonts": _vm.getThemeLanguageFonts,
      "available-languages": _vm.overrideAvailableLanguages
    },
    on: {
      "update:value": _vm.updateDefaultFont,
      "update:language-font": _vm.updateLanguageFont
    }
  })], 1)], 1)]) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }